/* eslint-disable */
import { Alert as AntdAlert, Space } from 'antd';
import React, { FC, useState } from 'react';
import { RangePicker } from 'components/molecules/range-picker';
import styled from 'styled-components';
import { Timestamp } from 'api/models';

const MediumWidth = styled.div`
  width: 350px;
`;

export const DemoRangeWithRelativePicker: FC = () => {
  const [date, setDate] = useState<[Timestamp | null, Timestamp | null]>([
    null,
    null,
  ]);

  return (
    <Space direction="vertical">
      <h3>Range dropdown with relative days and custom range picker</h3>
      <p>
        Selected dates: from {date[0]} to {date[1]}
      </p>
      <MediumWidth>
        <RangePicker onDateChange={(daterange) => setDate(daterange)} />
      </MediumWidth>
    </Space>
  );
};
